import { render, staticRenderFns } from "./PayBottom.vue?vue&type=template&id=f2506c10&scoped=true"
import script from "./PayBottom.vue?vue&type=script&lang=js"
export * from "./PayBottom.vue?vue&type=script&lang=js"
import style0 from "./PayBottom.vue?vue&type=style&index=0&id=f2506c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2506c10",
  null
  
)

export default component.exports